import React, {useState} from "react";
import {FormTab, Show, TextInput, TabbedForm, TopToolbar, NumberInput, EditButton, usePermissions} from 'react-admin';
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    pais: {display: 'inline-block', width: 400, marginLeft: 8},
    pais_codigo_afip: {display: 'inline-block', width: 200, marginLeft: 8},
    pais_codigo_gestion: {display: 'inline-block', width: 200, marginLeft: 8},
}));

const PaisShow = props => {
    const classes = useStyles();
    const { permissions } = usePermissions();
    var w_role_auxiliar_editar = ''
    var w_permissions_admuno_auxiliar_editar = permissions
    if(w_permissions_admuno_auxiliar_editar==null){}else{
        var wa_role_auxiliar_editar = w_permissions_admuno_auxiliar_editar.indexOf('ROLE_AUXILIAR_EDITAR')
        if(wa_role_auxiliar_editar===-1){}else{
            w_role_auxiliar_editar = 'ROLE_AUXILIAR_EDITAR'
        }
    }
    const [Pais, setPais] = useState('');
    const [PersonaTipo, setPersonaTipo] = useState('');
    // const [PaisSocioEstadoCivilCasado, setPaisSocioEstadoCivilCasado] = useState('');

    const establecerPais = value => {
        if (value == null || value === '') return '';
        setPais(value.trim());
        return value;
    };

    const establecerFecha = value => {
        if (value == null || value === '') return '';
        return value;
    };

    // Obtengo tipo de persona para cargar solapa correspondiente
    const establecerPersonaTipo = value => {
        if (value == null || value === '') return '';
        setPersonaTipo(value.trim());
        return value;
    };


    const cuitCuilFormat = value => {
        if (value == null || value === '') return '';

        //normalize string and remove all unnecessary characters
        var valueCuit = value.replace(/[^\d]/g, "");

        //check if number length equals to 11
        if (valueCuit.length == 11) {
            return value.replace(/(\d{2})(\d{8})(\d{1})/, "$1-$2-$3");
        }

        return value
    };

    // const establecerPaisSocioEstadoCivilCasado = value => {
    //     if (value == null || value === '') return '';
    //     setPaisSocioEstadoCivilCasado(value.trim());
    //     return value;
    // };

    const PostEditActions = ({basePath, data, resource}) => (
        <TopToolbar>
            {w_role_auxiliar_editar === 'ROLE_AUXILIAR_EDITAR' &&
                <EditButton basePath={basePath} record={data}/>
            }
        </TopToolbar>
    );

    const PostTitle = ({record}) => {
        return <span>Pais: {record ? `${record.pais}` : ''}</span>;
    };

    return (
        <Show title={<PostTitle/>} actions={<PostEditActions/>} {...props}>
            <TabbedForm toolbar={false}>
                <FormTab label="DATOS PAIS">

                    <NumberInput
                        id="standard-full-width"
                        label="Descripción Código AFIP"
                        source="pais_codigo_afip"
                        formClassName={classes.pais_codigo_afip}
                        placeholder="Ingrese Código AFIP Código AFIP"
                        helperText="Código AFIP"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{readOnly: true}}
                    />
                    <br/>

                    <NumberInput
                        id="standard-full-width"
                        label="Descripción Código Gestion"
                        source="pais_codigo_gestion"
                        formClassName={classes.pais_codigo_gestion}
                        placeholder="Ingrese Código Gestion Código Gestion"
                        helperText="Código Gestion"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{readOnly: true}}
                    />
                    <br/>

                    <TextInput
                        label="Pais"
                        source="pais"
                        formClassName={classes.pais}
                        multiline
                        fullWidth
                        placeholder="Ingrese Pais"
                        helperText="Pais"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{readOnly: true}}
                    />
                    <br/>

                </FormTab>
            </TabbedForm>
        </Show>
    )
};
export default PaisShow;


